<template>
  <div class="template template--two-column">
    <div class="template__content">
      <slot />
    </div>
    <Sidebar class="template__sidebar" />
  </div>
</template>

<script lang="ts">
  import Sidebar from '~/components/Sidebar.vue';

  export default defineNuxtComponent({
    name: 'TemplateTwoColumn',

    components: {
      Sidebar,
    },
  });
</script>

<style lang="scss" scoped>
  $sidebarWidth: 300px;
  $columnGap: 40px;

  .template {
    $root: &;

    &--two-column {
      @include desktop {
        display: grid;
        column-gap: $columnGap;
        grid-template-areas: 'content';
        grid-template-areas: 'content sidebar';
        grid-template-columns: calc(100% - $sidebarWidth - $columnGap) $sidebarWidth;
      }

      #{$root} {
        &__content {
          grid-area: content;
          display: flex;
          flex-direction: column;
        }

        &__sidebar {
          display: none;

          @include desktop {
            display: block;
            grid-area: sidebar;
          }
        }
      }
    }
  }
</style>
